import { useNavigate, useSearchParams } from 'react-router';
import { TabPathes } from '../../types';
import Button from '../ui/Button';
import ArrowsLine from '../../assets/icons/ArrowsLine';
import React from 'react';
import WalletGraph from '../WalletGraph';
import WalletOverlay from '../WalletOverlay';
import AssetCard from '../ui/AssetCard';
import Pagination from '../Pagination';
import { getAssets } from '../../api/assets';
import { useQuery } from '@tanstack/react-query';

const LIMIT = 2;

const UserTab = () => {
  const navigate = useNavigate();
  const goToData = (path: string) => navigate('/' + path);

  const [searchParams] = useSearchParams();

  const { data } = useQuery({
    queryKey: ['media-assets'],
    queryFn: () => getAssets({ asset_type: 'media' }),
    staleTime: 1000 * 30,
  });

  const mediaAssets = data ? data.results.results : [];

  const page = searchParams.get('page');
  const currentPage = page ? Number(page) : 1;

  const pages = Math.ceil(mediaAssets.length / LIMIT);

  const startIndex = (currentPage - 1) * LIMIT;
  const slicedAssets = mediaAssets.slice(startIndex, startIndex + LIMIT);

  return (
    <div className='mt-[20px] flex flex-1 flex-col justify-between'>
      <div className='flex flex-1 flex-col gap-3'>
        <h2 className='text-base font-medium text-white'>Your Assets:</h2>

        <div className='grid grid-cols-2 gap-3'>
          {mediaAssets.length >= 2 ? (
            slicedAssets.map((asset) => (
              <AssetCard
                onClick={() => goToData(TabPathes.ASSETS)}
                type={asset.type}
                name={asset.name}
                description={asset.description}
                thumbnail={asset.thumbnail}
              />
            ))
          ) : (
            <>
              <AssetCard
                onClick={() => goToData(TabPathes.ASSETS)}
                name='Monetise your music & assets'
                thumbnail='/images/music.jpg'
              />

              <AssetCard
                onClick={() => goToData(TabPathes.ASSETS)}
                name='Monetise your social media presence'
                thumbnail='/images/social_media.png'
              />
            </>
          )}
        </div>

        {mediaAssets.length > 2 && (
          <Pagination pages={pages} url={TabPathes.DASHBOARD} />
        )}

        <div
          className={`
            relative overflow-hidden rounded-xl border border-[#353644]
            bg-[linear-gradient(317.83deg,rgba(53,54,68,0.66)_-7.3%,rgba(20,19,24,0.66)_107.21%)]
            p-2
          `}
        >
          <WalletGraph />

          <WalletOverlay />
        </div>
      </div>

      <Button
        className='mt-3'
        onClick={() => goToData(TabPathes.DATA)}
        variant='solid'
        iconBack={<ArrowsLine color='currentColor' />}
      >
        Connect your data
      </Button>
    </div>
  );
};

export default UserTab;
